/**
 * @file 搜索页
 * @author wangzhuang
 */


import {rcAjax} from '../util';
import {GET_CMSAPI_SEARCHARTICLE} from './ActionTypes';

export function fetchCmsapiSearchArticle(dispatch, aidObj, isMore) {
    return rcAjax('GET', '/cmsapi/searchArticle', aidObj, {}, data => {
        dispatch({type: GET_CMSAPI_SEARCHARTICLE, data: data.data, isMore: isMore});
    });
}






// WEBPACK FOOTER //
// ./src/actions/searchAction.js